import { getRequest } from '@/core';
import { edi } from '@/requests';

export default async function() {
	let url = edi.metadata();
	let response = await getRequest(url);
	return response;
}